import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, PageHeader, Button, Icon, Checkbox, Table, Input, Pagination, message } from "antd";
import { getDocuments } from "../actions";
import { Session } from "../../../business";
import { baseUrl } from "../../../constants/enviroment";
import NewRegister from "./register/index";
import NewElaborate from "./elaborate/index";
import { Link } from "react-router-dom";
import { ExportButtons } from "../../../components/ListButtons/exportTo";
import { ClearFilterButton } from "../../../components/ListButtons/clearFilter";

const ModelsDocuments = () => {
    const [filter, setfilter] = useState({
        sorter: {
            columnKey: "codigo",
            order: "ascend",
        },
    });
    const [loadingData, setLoadingData] = useState(false);
    const [isVisibleRegister, showNewRegister] = useState(null);
    const [isVisibleElaborate, showNewElaborate] = useState(null);
    const [dataSource, setDataSource] = useState([]);
    const [metadata, setMetadata] = useState({});
    const [showObsolete, setShowObsolete] = useState(false);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        currentPageSize: 10,
    });

    useEffect(() => {
        setLoadingData(true);
        const { sorter, ...objFilter } = filter;

        const values = {
            ...objFilter,
            pagina: pagination.currentPage,
            resultados_pagina: pagination.currentPageSize,
        };

        if (sorter && sorter.order) {
            const columnSort = sorter.order === "ascend" ? "ASC" : sorter.order === "descend" ? "DESC" : null;
            values["ordenacao_" + sorter.columnKey] = columnSort;
        }

        if (showObsolete) {
            values.obsoletos = "true";
        }

        getDocuments(values).then((response) => {
            if (response) {
                setDataSource(response.lista);
                setMetadata(response.metadata);
            } else {
                message.error("Ocorreu um erro");
            }

            setLoadingData(false);
        });
    }, [pagination, filter, showObsolete]);

    const getColumnSearchProps = (dataIndex) => {
        const searchInput = React.createRef();
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={searchInput}
                        placeholder={`Pesquisar`}
                        value={selectedKeys}
                        onChange={(e) => setSelectedKeys(e.target.value ? e.target.value : null)}
                        onPressEnter={() => handleSearch(selectedKeys, confirm)}
                        style={{
                            width: 188,
                            marginBottom: 8,
                            display: "block",
                        }}
                    />
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm)}
                        icon="search"
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Pesquisar
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        limpar
                    </Button>
                </div>
            ),
            filterIcon: (filtered) => <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />,
            filteredValue: filter[`filtro_${dataIndex}`] || null,
        };
    };

    const clearFormFilters = () => {
        setPagination({
            ...pagination,
            currentPage: 1,
        });
        setfilter({});
    };

    const handleSearch = (selectedKeys, confirm) => {
        confirm();
    };

    const handleReset = (clearFilters) => {
        clearFilters();
    };

    const getColumnSortProps = (dataIndex, sortedInfo) => ({
        sorter: true,
        sortOrder: sortedInfo.columnKey === dataIndex && sortedInfo.order,
    });

    const sortedInfo = filter.sorter || {};

    const column = [
        {
            title: "Código",
            dataIndex: "codigo",
            ...getColumnSearchProps("codigo"),
            ...getColumnSortProps("codigo", sortedInfo),
        },
        {
            title: "Nome",
            dataIndex: "nome",
            ...getColumnSearchProps("nome"),
            ...getColumnSortProps("nome", sortedInfo),
        },
        {
            title: "Código Externo",
            dataIndex: "codigo_externo",
            ...getColumnSearchProps("codigo_externo"),
            ...getColumnSortProps("codigo_externo", sortedInfo),
        },
        {
            title: "Versão",
            dataIndex: "versao",
            ...getColumnSearchProps("versao"),
            ...getColumnSortProps("versao", sortedInfo),
        },
        {
            title: "Estado",
            dataIndex: "estado",
            ...getColumnSearchProps("estado"),
            ...getColumnSortProps("estado", sortedInfo),
        },
        {
            title: "Ação",
            render: (_, row) => <Link to={`/models/documents/edit/${row.id}`}>Consultar</Link>,
        },
    ];

    const handleTableChange = (_pagination, filters, sorter) => {
        const obj = {};
        if (filters) {
            Object.entries(filters).forEach(([key, val]) => {
                if (val) obj["filtro_" + key] = val;
            });
        }
        if (sorter.columnKey && sorter.order) {
            obj["sorter"] = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
        }

        setPagination({
            ...pagination,
            currentPage: 1,
        });

        setfilter(obj);
    };

    const handleShowSizeChange = (currentPage, currentPageSize) => {
        setPagination({
            currentPage: 1,
            currentPageSize,
        });
    };

    const pageChange = (currentPage, currentPageSize) => {
        setPagination({
            currentPage,
            currentPageSize,
        });
    };

    const exportList = (type) => {
        try {
            const formData = new FormData();
            formData.append("accao", "lista");
            formData.append("saida", type);
            formData.append(
                "campos",
                "codigo:248:Código;nome:620:Nome;codigo_externo:187:Código Externo;versao:187:Versão;estado:187:Estado;"
            );
            Object.entries(filter).forEach(([key, val]) => {
                formData.append(key, val);
            });
            formData.append("titulo", "Modelos de Documentos");

            var request = new XMLHttpRequest();
            request.open("POST", baseUrl + "/Gestor/gereformulario.php", true);

            request.setRequestHeader("Authorization", `Bearer ${Session.getToken()}`);
            request.responseType = "blob";

            request.onload = function () {
                // Only handle status code 200
                if (request.status === 200) {
                    // Try to find out the filename from the content disposition `filename` value
                    var disposition = request.getResponseHeader("content-disposition");
                    //
                    var matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                    //

                    var filename = matches != null && matches[1] ? matches[1] : "Modelos de Documentos";

                    // The actual download
                    var blob = new Blob([request.response], {
                        type: request.getResponseHeader("content-type"),
                    });

                    var link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;

                    document.body.appendChild(link);

                    link.click();

                    document.body.removeChild(link);
                }

                // some error handling should be done here...
            };

            request.send(formData);
            // const formData = new FormData();
            // formData.append("lista", listName);

            // const body = await sendHttpRequest(
            //   "POST",
            //   "Gestor/gereRelatorio.php",
            //   formData,
            // );
            //
        } catch (error) {}
    };

    const showClearFilterButton = useMemo(() => {
        if (Object.keys(filter).length !== 0) {
            return true;
        }

        return false;
    }, [filter]);

    return (
        <div>
            <PageHeader title="Modelos de Documentos" />
            <Row type="flex" style={{ justifyContent: "space-between" }}>
                <div>
                    <Button
                        onClick={() => showNewRegister({})}
                        type="primary"
                        style={{
                            float: "right",
                            marginLeft: 8,
                            marginBottom: 16,
                        }}
                    >
                        <Icon type="plus" />
                        Registar
                    </Button>
                    <Button
                        onClick={() => showNewElaborate({})}
                        type="primary"
                        style={{
                            float: "right",
                            marginLeft: 8,
                            marginBottom: 16,
                        }}
                    >
                        <Icon type="plus" />
                        Elaborar
                    </Button>
                </div>

                <div>
                    <Checkbox onChange={(e) => setShowObsolete(e.target.checked)}>Incluir Obsoletos</Checkbox>
                    {showClearFilterButton && <ClearFilterButton onClick={clearFormFilters} />}
                    <ExportButtons onExport={exportList} />
                </div>
            </Row>
            <Table
                rowKey="id_controlo_documento"
                columns={column}
                pagination={false}
                dataSource={dataSource}
                loading={loadingData}
                onChange={handleTableChange}
            />
            <Row>
                <Col xs={24}>
                    <Pagination
                        current={pagination.currentPage}
                        defaultPageSize={pagination.currentPageSize}
                        size="small"
                        total={metadata.resultados}
                        showSizeChanger
                        showTotal={(total) => `Total de ${total} registo.`}
                        onChange={pageChange}
                        onShowSizeChange={handleShowSizeChange}
                        showTitle
                        showLessItems={true}
                        defaultCurrent={1}
                        style={{ float: "right", marginTop: 16 }}
                    />
                </Col>
            </Row>
            <NewRegister isVisible={isVisibleRegister} showNewRegister={showNewRegister.bind(this)} />
            <NewElaborate isVisible={isVisibleElaborate} showNewElaborate={showNewElaborate.bind(this)} />
        </div>
    );
};

export default ModelsDocuments;
